<template>
  <div class="main">
    <div class="top">
      <div style="float:left" @click="back"><img src="@/assets/return1.png" alt=""></div>
      <h5 class="title">《金声玉亮用户协议》 正文</h5>
    </div>
    <van-pagination 
      v-model="currentPage" 
      style="margin-top:30px" 
      :page-count="pageCount" 
      mode="simple" 
      @change="onPageChange"
    />
    <!-- <pdf
      ref="pdf"
      style=""
      :src="userServicePdf.default"
      :page="currentPage"
      @num-pages="pageCount = $event"
      @page-loaded="onPageLoaded"
    /> -->
    <pdf
      ref="pdf"
      style=""
      src="
https://homepage-oss.oss-cn-beijing.aliyuncs.com/h5/%E9%87%91%E5%A3%B0%E7%8E%89%E4%BA%AE%E7%94%A8%E6%88%B7%E5%8D%8F%E8%AE%AE.pdf"
      :page="currentPage"
      @num-pages="pageCount = $event"
      @page-loaded="onPageLoaded"
    />
  </div>
</template>

<script>
import pdf from 'vue-pdf'
import { Pagination } from 'vant'
export default {
  components: {
    [Pagination.name]: Pagination,
    pdf
  },
  data() {
    return {
      currentPage: 1,
      pageCount: 0,
      // userServicePdf: require('@/assets/pdf/userservice.pdf')
    }
  },
  methods: {
    // 分页组件页码变化时触发
    onPageChange(page) {
      this.currentPage = page
    },

    onPageLoaded(page) {
      console.log('页面加载完成:', page)
    },

    prePage() {
      if (this.currentPage > 1) {
        this.currentPage = this.currentPage - 1
      }
    },
    
    nextPage() {
      if (this.currentPage < this.pageCount) {
        this.currentPage = this.currentPage + 1
      }
    },
    
    back() {
      this.$router.go(-1)
    }
  }
  
}
</script>

<style scoped>
p{
    text-indent: 2em;
    margin: 0.5rem 0;
    font-size: 1rem;
    line-height: 25px;
}
h1{
    font-size: 18px;
    font-weight: 700;
}
.main{
    padding: 2.0vw
}
.top{
    width: 100vw;
    padding: 2.0vw;
    position: fixed;
    top: 0;
    left: 0;
    background: #f0f3f6;
}
.title,.second{
   text-align: center
}
.second{
    margin-top: 5vh;
    font-weight: 700;
    font-size: 20px;
}
</style>

